import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../api';

function LegalInfo() {
  const [privacidad, setPrivacidad] = useState('');
  const [aviso, setAviso] = useState('');

  const cargarPrivacidad = async () => {
    const apiUrl = `${API_BASE}/api/legal/privacidad`;
    const res = await axios.get(apiUrl);
    setPrivacidad(res.data.contenido);
  };

  const cargarAviso = async () => {
    const apiUrl = `${API_BASE}/api/legal/aviso`;
    const res = await axios.get(apiUrl);
    setAviso(res.data.contenido);
  };

  return (
    <div>
      <h2>Información Legal</h2>
      <button onClick={cargarPrivacidad}>Ver Política de Privacidad</button>
      {privacidad && <p>{privacidad}</p>}
      <button onClick={cargarAviso}>Ver Aviso Legal</button>
      {aviso && <p>{aviso}</p>}
    </div>
  );
}

export default LegalInfo;
